import { Model } from '@/model/Model'
import { BaseChildState } from './BaseChildState'
import { BaseState } from './BaseState'
import { IChildState } from './IStateMachine'
import { IStateMachine } from './IStateMachine'

export class BaseParentState extends BaseState {
    protected readonly _childStates: BaseChildState[]
    protected _activeIndex: number

    public constructor(stateMachine: IStateMachine, model: Model, id: string) {
        super(stateMachine, model, id)

        this._childStates = []
        this._activeIndex = 0
    }

    public addChild(stateType: IChildState, id: string) {
        this._childStates.push(new stateType(this, this._stateMachine, this._model, id))
    }

    public beginChild() {
        const state = this._childStates[this._activeIndex]

        if (state != null) {
            if (!state.canTrigger()) {
                this._activeIndex++
                this.beginChild()
                return
            }

            this._stateMachine.applyState(state.id)
            state.begin()

            return
        }

        this.end()
    }

    public restartChild() {
        this._childStates[this._activeIndex].cleanUp()
        this._activeIndex = 0
        this.beginChild()
    }

    public endChild() {
        this._childStates[this._activeIndex].cleanUp()
        this._activeIndex++
        this.beginChild()
    }

    public begin() {
        this._activeIndex = 0
        this.beginChild()
    }

    public end = () => {
        // empty
    }

    public cleanUp() {
        // empty
    }
}
